export const defaultLocationObject = {
    address: null
};

export const firstLocationObject = {
    address: null,
    locNumber: '1'
};

export default [firstLocationObject];
  